import { render, staticRenderFns } from "./DownButton.vue?vue&type=template&id=6bd30dfa&"
import script from "./DownButton.vue?vue&type=script&lang=js&"
export * from "./DownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports